import "./Main.css";
import img from './img/dev.png';

const Main = () => {
  return (
    <div className="main">
      <img src={ img } alt="main"/>
    </div>
  );
};
export default Main;
